// extracted by mini-css-extract-plugin
export var Img = "v_K";
export var aniSpin = "v_d";
export var img = "v_M";
export var isFull = "v_L";
export var placeholder = "v_N";